import React from "react";
import { Droppable } from "@hello-pangea/dnd";
import OrderCard from "./OrderCard";

const statusStyles = {
  "order received": {
    heading: "bg-red-500 text-white",
    column: "bg-red-50",
    ring: "ring-red-100",
  },
  processing: {
    heading: "bg-yellow-400 text-white",
    column: "bg-yellow-50",
    ring: "ring-yellow-100",
  },
  completed: {
    heading: "bg-green-500 text-white",
    column: "bg-green-50",
    ring: "ring-green-100",
  },
};

export default function OrdersColumn({
  droppableId,
  statusLabel,
  orders,
  expandedOrderId,
  toggleOrder,
  footer,
  refetchOrders,
}) {
  const disableDrag = droppableId === "completed";

  const styles = statusStyles[statusLabel] || {
    heading: "bg-slate-800 text-white",
    column: "bg-slate-50",
    ring: "ring-slate-200",
  };

  return (
    <Droppable droppableId={droppableId}>
      {(provided) => (
        <div
          className={`flex h-full min-h-0 min-w-[350px] flex-1 shrink-0 basis-0 flex-col overflow-hidden rounded-3xl ${styles.column} shadow-sm ring-1 ${styles.ring}`}
        >
          <div className="p-3 pb-0 lg:p-4 lg:pb-0">
            <h2
              className={`sticky top-0 z-10 mb-3 rounded-2xl px-3 py-2.5 text-center text-xs font-bold uppercase tracking-[0.14em] lg:mb-4 lg:px-4 lg:py-3 lg:text-sm ${styles.heading}`}
            >
              {statusLabel} ({orders.length})
            </h2>
          </div>

          <div
            id="orders-column-scroll"
            ref={provided.innerRef}
            {...provided.droppableProps}
            className="orders-scrollbar min-h-0 flex-1 overflow-y-auto px-3 pb-3 lg:px-4 lg:pb-4"
          >
            <ul className="space-y-3">
              {orders.map((order, index) => (
                <OrderCard
                  key={order.id}
                  order={order}
                  index={index}
                  expanded={expandedOrderId === order.id}
                  onToggle={() => toggleOrder(order.id)}
                  refetchOrders={refetchOrders}
                  disableDrag={disableDrag}
                />
              ))}

              {provided.placeholder}
            </ul>
          </div>

          {orders.length > 0 && footer && (
            <div className="px-3 pb-3 lg:px-4 lg:pb-4">{footer}</div>
          )}
        </div>
      )}
    </Droppable>
  );
}